module.exports = __webpack_public_path__ + "media/1alB-w-wi.02a57729.mp3";